import { Component, OnInit, ViewChild } from '@angular/core';
import { Absence, AbsenceHistory } from '../../absences.model';
import { GridComponent } from '../../../core/shared/grid/grid.component';

@Component({
  selector: 'app-absence-history',
  templateUrl: './absence-history.component.html',
  styleUrls: []
})
export class AbsenceHistoryComponent implements OnInit {

  constructor() { }
  public history: AbsenceHistory[];

  @ViewChild(GridComponent) grid: GridComponent;

  ngOnInit() {
  }

  private headers = [
    { displayName: 'Użytkownik', propertyName: 'employeeFullName', propertyType: 'string' },
    { displayName: 'Status', propertyName: 'stateName', propertyType: 'string' },
    { displayName: 'Data', propertyName: 'createdDate', propertyType: 'date', dateFormat: 'dd.MM.yyyy HH:mm', isInitSort: true, isInitSortAsc: false }
  ];


  public setModel(absence: Absence) {
    this.history = absence.history;
  }

}
